import { logger } from '@/services/logger';
import { HttpStatus } from '@d-id/http-status';
import axios from 'axios';

const nonRetryableErrors = [
    HttpStatus.BAD_REQUEST,
    HttpStatus.UNAUTHORIZED,
    HttpStatus.FORBIDDEN,
    HttpStatus.NOT_FOUND,
    HttpStatus.METHOD_NOT_ALLOWED,
    HttpStatus.GONE,
    HttpStatus.LENGTH_REQUIRED,
    HttpStatus.PAYLOAD_TOO_LARGE,
    HttpStatus.URI_TOO_LONG,
    HttpStatus.UNSUPPORTED_MEDIA_TYPE,
    HttpStatus.REQUESTED_RANGE_NOT_SATISFIABLE,
    HttpStatus.EXPECTATION_FAILED,
    HttpStatus.UNPROCESSABLE_ENTITY,
    HttpStatus.UNAVAILABLE_FOR_LEGAL_REASONS,
];
interface RetryOptions<T> {
    fn: () => Promise<T>;
    retries: number;
    initialDelay: number;
    fnLogName: string;
    signal?: AbortSignal;
}
export const retryWithDelay = async <T>({ fn, retries, initialDelay, signal, fnLogName }: RetryOptions<T>) => {
    let delay = initialDelay;

    for (let attempt = 1; attempt <= retries; attempt++) {
        if (signal?.aborted) {
            return;
        }

        try {
            return await fn();
        } catch (error) {
            if (signal?.aborted || axios.isCancel(error)) {
                logger.debug(`Aborted ${fnLogName}, will not retry`, error);
                return;
            }

            const shouldNotRetry = axios.isAxiosError(error) && nonRetryableErrors.includes(error.response?.status || 0);

            if (attempt < retries && !shouldNotRetry) {
                await new Promise(resolve => setTimeout(resolve, delay));
                delay *= 2;
            } else {
                logger.error(`Failed to execute ${fnLogName}. Error retryable: ${!shouldNotRetry} attempt ${attempt}/${retries}`, {
                    error,
                    errorAsString: JSON.stringify(error),
                });
                throw error;
            }
        }
    }
};
